/**
 * Tells the ADP pages how much of the top of the screen the theme's header covers (CSS variable --head-h on <html>), so the pinned hero
 * and the sub-menu sit directly under it. Works with a sticky header (Dawn's <sticky-header>, also the "hide on scroll down" kind)
 * and with a header that scrolls away (then the value drops to 0).
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var header = document.querySelector("sticky-header") || document.querySelector(".section-header") || document.querySelector("header");
  function setHeadH() {
    var h = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      var rect = header.getBoundingClientRect();
      h = Math.max(0, Math.round(rect.bottom));
      if (pos !== "sticky" && pos !== "fixed" && rect.bottom <= 0) h = 0;
    }
    root.style.setProperty("--head-h", h + "px");
  }
  setHeadH();
  window.addEventListener("scroll", setHeadH, { passive: true });
  window.addEventListener("resize", setHeadH);
  window.addEventListener("load", setHeadH);
  if (header && "ResizeObserver" in window) new ResizeObserver(setHeadH).observe(header);
  window.LamexHeader = { setHeadH: setHeadH };
})();
